/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../../public/upgrade/feature/carTemplate/moderate/car-template-moderate.component';
import * as import1 from '@angular/core/src/linker/view';
import * as import2 from '@angular/core/src/render/api';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/metadata/view';
import * as import5 from '../../../../../../public/upgrade/feature/carTemplate/car-template.service';
import * as import6 from '@angular/core/src/linker/view_type';
import * as import7 from '@angular/core/src/change_detection/constants';
import * as import8 from '@angular/core/src/linker/component_factory';
import * as import9 from '@angular/http/src/http';
import * as import10 from '../../../../../../public/upgrade/root/modal/modal.service';
import * as import11 from '../../../../../../public/upgrade/root/toast/notification.service';
import * as import12 from '../../../../../../public/upgrade/core/geo_a2.service';
import * as import13 from '../../../../../../public/upgrade/root/loading/loading-wheel.service';
import * as import14 from '@angular/router/src/router';
import * as import15 from '@angular/router/src/router_state';
import * as import16 from '@ngx-translate/core/src/translate.service';
import * as import17 from '../../../../../../public/upgrade/core/session.service';
import * as import18 from '@angular/core/src/zone/ng_zone';
import * as import19 from '../../../../../node_modules/@angular/forms/src/directives/select_control_value_accessor.ngfactory';
import * as import20 from '../../../../../node_modules/@angular/forms/src/directives/select_multiple_control_value_accessor.ngfactory';
import * as import21 from '@ngx-translate/core/src/translate.pipe';
import * as import22 from '@angular/core/src/linker/view_container';
import * as import23 from '@angular/core/src/change_detection/change_detection_util';
import * as import24 from '@angular/core/src/linker/element_ref';
import * as import25 from '@angular/forms/src/directives/select_control_value_accessor';
import * as import26 from '@angular/forms/src/directives/select_multiple_control_value_accessor';
import * as import27 from '@angular/core/src/security';
import * as import28 from '../../../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import29 from '@angular/core/src/linker/template_ref';
import * as import30 from '@angular/common/src/directives/ng_if';
import * as import31 from '../../../../../../public/upgrade/feature/carTemplate/list/card/car-template-list-card.component';
import * as import32 from '../list/card/car-template-list-card.component.ngfactory';
import * as import33 from '../../../../../node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import34 from '../../../../../../public/upgrade/shared/pager/eva-pager.component';
import * as import35 from '../../../shared/pager/eva-pager.component.ngfactory';
import * as import36 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import37 from '@angular/common/src/directives/ng_for';
import * as import38 from '../../../../../node_modules/@angular/forms/src/directives/ng_model.ngfactory';
import * as import39 from '../../../../../node_modules/@angular/forms/src/directives/ng_control_status.ngfactory';
import * as import40 from '@angular/common/src/pipes/date_pipe';
import * as import41 from '@angular/core/src/i18n/tokens';
import * as import42 from '@angular/forms/src/directives/control_value_accessor';
import * as import43 from '@angular/forms/src/directives/ng_model';
import * as import44 from '@angular/forms/src/directives/ng_control';
import * as import45 from '@angular/forms/src/directives/ng_control_status';
export class Wrapper_CarTemplateModerateComponent {
  /*private*/ _eventHandler:Function;
  context:import0.CarTemplateModerateComponent;
  /*private*/ _changed:boolean;
  constructor(p0:any,p1:any,p2:any,p3:any,p4:any,p5:any,p6:any,p7:any,p8:any,p9:any) {
    this._changed = false;
    this.context = new import0.CarTemplateModerateComponent(p0,p1,p2,p3,p4,p5,p6,p7,p8,p9);
  }
  ngOnDetach(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
  }
  ngDoCheck(view:import1.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  checkHost(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import1.AppView<any>,_eventHandler:any):void {
    this._eventHandler = _eventHandler;
  }
}
var renderType_CarTemplateModerateComponent_Host:import2.RenderComponentType = import3.createRenderComponentType('',0,import4.ViewEncapsulation.None,([] as any[]),{});
class View_CarTemplateModerateComponent_Host0 extends import1.AppView<any> {
  _el_0:any;
  compView_0:import1.AppView<import0.CarTemplateModerateComponent>;
  _CarTemplateService_0_3:import5.CarTemplateService;
  _CarTemplateModerateComponent_0_4:Wrapper_CarTemplateModerateComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_CarTemplateModerateComponent_Host0,renderType_CarTemplateModerateComponent_Host,import6.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'car-template-moderate',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_CarTemplateModerateComponent0(this.viewUtils,this,0,this._el_0);
    this._CarTemplateService_0_3 = new import5.CarTemplateService(this.injectorGet(import9.Http,this.parentIndex));
    this._CarTemplateModerateComponent_0_4 = new Wrapper_CarTemplateModerateComponent(this.injectorGet(import10.ModalService,this.parentIndex),this.injectorGet(import11.NotificationService,this.parentIndex),this.injectorGet(import12.GeoServiceA2,this.parentIndex),this.injectorGet(import13.LoadingWheelService,this.parentIndex),this.injectorGet(import14.Router,this.parentIndex),this.injectorGet(import15.ActivatedRoute,this.parentIndex),this.injectorGet(import16.TranslateService,this.parentIndex),this.injectorGet(import17.SessionService,this.parentIndex),this._CarTemplateService_0_3,this.injectorGet(import18.NgZone,this.parentIndex));
    this.compView_0.create(this._CarTemplateModerateComponent_0_4.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import8.ComponentRef_<any>(0,this,this._el_0,this._CarTemplateModerateComponent_0_4.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import5.CarTemplateService) && (0 === requestNodeIndex))) { return this._CarTemplateService_0_3; }
    if (((token === import0.CarTemplateModerateComponent) && (0 === requestNodeIndex))) { return this._CarTemplateModerateComponent_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._CarTemplateModerateComponent_0_4.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const CarTemplateModerateComponentNgFactory:import8.ComponentFactory<import0.CarTemplateModerateComponent> = new import8.ComponentFactory<import0.CarTemplateModerateComponent>('car-template-moderate',View_CarTemplateModerateComponent_Host0,import0.CarTemplateModerateComponent);
const styles_CarTemplateModerateComponent:any[] = ([] as any[]);
class View_CarTemplateModerateComponent1 extends import1.AppView<any> {
  _el_0:any;
  _NgSelectOption_0_3:import19.Wrapper_NgSelectOption;
  _NgSelectMultipleOption_0_4:import20.Wrapper_NgSelectMultipleOption;
  _text_1:any;
  /*private*/ _expr_4:any;
  _pipe_translate_0:import21.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import22.ViewContainer) {
    super(View_CarTemplateModerateComponent1,renderType_CarTemplateModerateComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_4 = import23.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'option',new import3.InlineArray2(2,'class','select-option'),(null as any));
    this._NgSelectOption_0_3 = new import19.Wrapper_NgSelectOption(new import24.ElementRef(this._el_0),this.renderer,(<View_CarTemplateModerateComponent0>this.parentView)._SelectControlValueAccessor_38_3.context);
    this._NgSelectMultipleOption_0_4 = new import20.Wrapper_NgSelectMultipleOption(new import24.ElementRef(this._el_0),this.renderer,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._pipe_translate_0 = new import21.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import25.NgSelectOption) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._NgSelectOption_0_3.context; }
    if (((token === import26.NgSelectMultipleOption) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._NgSelectMultipleOption_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import23.ValueUnwrapper();
    const currVal_0_0_0:any = this.context.$implicit;
    this._NgSelectOption_0_3.check_ngValue(currVal_0_0_0,throwOnChange,false);
    this._NgSelectOption_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    const currVal_0_1_0:any = this.context.$implicit;
    this._NgSelectMultipleOption_0_4.check_ngValue(currVal_0_1_0,throwOnChange,false);
    this._NgSelectMultipleOption_0_4.ngDoCheck(this,this._el_0,throwOnChange);
    valUnwrapper.reset();
    const currVal_4:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform(('carTemplate.approvalStatus.' + this.context.$implicit))),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_4,currVal_4))) {
      this.renderer.setText(this._text_1,currVal_4);
      this._expr_4 = currVal_4;
    }
  }
  destroyInternal():void {
    this._NgSelectOption_0_3.ngOnDestroy();
    this._NgSelectMultipleOption_0_4.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_CarTemplateModerateComponent2 extends import1.AppView<any> {
  _el_0:any;
  _NgSelectOption_0_3:import19.Wrapper_NgSelectOption;
  _NgSelectMultipleOption_0_4:import20.Wrapper_NgSelectMultipleOption;
  _text_1:any;
  /*private*/ _expr_4:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import22.ViewContainer) {
    super(View_CarTemplateModerateComponent2,renderType_CarTemplateModerateComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_4 = import23.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'option',new import3.InlineArray2(2,'class','select-option'),(null as any));
    this._NgSelectOption_0_3 = new import19.Wrapper_NgSelectOption(new import24.ElementRef(this._el_0),this.renderer,(<View_CarTemplateModerateComponent0>this.parentView)._SelectControlValueAccessor_55_3.context);
    this._NgSelectMultipleOption_0_4 = new import20.Wrapper_NgSelectMultipleOption(new import24.ElementRef(this._el_0),this.renderer,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import25.NgSelectOption) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._NgSelectOption_0_3.context; }
    if (((token === import26.NgSelectMultipleOption) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._NgSelectMultipleOption_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_0_0_0:any = this.context.$implicit.id;
    this._NgSelectOption_0_3.check_ngValue(currVal_0_0_0,throwOnChange,false);
    this._NgSelectOption_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    const currVal_0_1_0:any = this.context.$implicit.id;
    this._NgSelectMultipleOption_0_4.check_ngValue(currVal_0_1_0,throwOnChange,false);
    this._NgSelectMultipleOption_0_4.ngDoCheck(this,this._el_0,throwOnChange);
    const currVal_4:any = import3.inlineInterpolate(1,'',this.context.$implicit.descriptions[this.parentView.context.lang],'');
    if (import3.checkBinding(throwOnChange,this._expr_4,currVal_4)) {
      this.renderer.setText(this._text_1,currVal_4);
      this._expr_4 = currVal_4;
    }
  }
  destroyInternal():void {
    this._NgSelectOption_0_3.ngOnDestroy();
    this._NgSelectMultipleOption_0_4.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_CarTemplateModerateComponent5 extends import1.AppView<any> {
  _el_0:any;
  /*private*/ _expr_1:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import22.ViewContainer) {
    super(View_CarTemplateModerateComponent5,renderType_CarTemplateModerateComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_1 = import23.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'img',new import3.InlineArray2(2,'loading','lazy'),(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_1:any = ((this.parentView.context.$implicit.carModel == null)? (null as any): this.parentView.context.$implicit.carModel.picture.url);
    if (import3.checkBinding(throwOnChange,this._expr_1,currVal_1)) {
      this.renderer.setElementProperty(this._el_0,'src',this.viewUtils.sanitizer.sanitize(import27.SecurityContext.URL,currVal_1));
      this._expr_1 = currVal_1;
    }
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_CarTemplateModerateComponent6 extends import1.AppView<any> {
  _el_0:any;
  /*private*/ _expr_1:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import22.ViewContainer) {
    super(View_CarTemplateModerateComponent6,renderType_CarTemplateModerateComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_1 = import23.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'img',new import3.InlineArray2(2,'loading','lazy'),(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_1:any = ((this.parentView.context.$implicit.carModel == null)? (null as any): this.parentView.context.$implicit.carModel.auxPicture.url);
    if (import3.checkBinding(throwOnChange,this._expr_1,currVal_1)) {
      this.renderer.setElementProperty(this._el_0,'src',this.viewUtils.sanitizer.sanitize(import27.SecurityContext.URL,currVal_1));
      this._expr_1 = currVal_1;
    }
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_CarTemplateModerateComponent8 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _text_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _el_10:any;
  _text_11:any;
  _text_12:any;
  _text_13:any;
  /*private*/ _expr_14:any;
  _pipe_translate_0:import21.TranslatePipe;
  /*private*/ _expr_16:any;
  _pipe_translate_1:import21.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import22.ViewContainer) {
    super(View_CarTemplateModerateComponent8,renderType_CarTemplateModerateComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_14 = import23.UNINITIALIZED;
    this._expr_16 = import23.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'qadata','moderation-menu'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                                ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'a',new import3.InlineArray4(4,'class','eva-btn -md -loader -secondary','style','text-decoration: none'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                                                    ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'em',new import3.InlineArray2(2,'class','btn-text'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'',(null as any));
    this._text_6 = this.renderer.createText(this._el_2,'\n                                                ',(null as any));
    this._text_7 = this.renderer.createText(this._el_0,'\n                                                ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_0,'a',new import3.InlineArray4(4,'class','eva-btn -loader -default -md','style','text-decoration: none'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'\n                                                    ',(null as any));
    this._el_10 = import3.createRenderElement(this.renderer,this._el_8,'em',new import3.InlineArray2(2,'class','btn-text'),(null as any));
    this._text_11 = this.renderer.createText(this._el_10,'',(null as any));
    this._text_12 = this.renderer.createText(this._el_8,'\n                                                ',(null as any));
    this._text_13 = this.renderer.createText(this._el_0,'\n                                            ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_2,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_2));
    this._pipe_translate_0 = new import21.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.parentView.parentView.parentView.parentView.ref);
    var disposable_1:Function = import3.subscribeToRenderElement(this,this._el_8,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_8));
    this._pipe_translate_1 = new import21.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.parentView.parentView.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._text_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._text_12,
      this._text_13
    ]
    ),[
      disposable_0,
      disposable_1
    ]
    );
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import23.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_14:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('carTemplate.moderation.VALIDATE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_14,currVal_14))) {
      this.renderer.setText(this._text_5,currVal_14);
      this._expr_14 = currVal_14;
    }
    valUnwrapper.reset();
    const currVal_16:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform('carTemplate.moderation.REJECT')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_16,currVal_16))) {
      this.renderer.setText(this._text_11,currVal_16);
      this._expr_16 = currVal_16;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_2(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.parentView.parentView.parentView.parentView.context.moderate(this.parentView.parentView.context.$implicit,'APPROVED')) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_8(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.parentView.parentView.parentView.parentView.context.moderate(this.parentView.parentView.context.$implicit,'REJECTED')) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
class View_CarTemplateModerateComponent9 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _text_6:any;
  _text_7:any;
  /*private*/ _expr_8:any;
  _pipe_translate_0:import21.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import22.ViewContainer) {
    super(View_CarTemplateModerateComponent9,renderType_CarTemplateModerateComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_8 = import23.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'qadata','moderation-menu'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                                ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'a',new import3.InlineArray4(4,'class','eva-btn -md -loader -secondary','style','text-decoration: none'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                                                    ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'em',new import3.InlineArray2(2,'class','btn-text'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'',(null as any));
    this._text_6 = this.renderer.createText(this._el_2,'\n                                                ',(null as any));
    this._text_7 = this.renderer.createText(this._el_0,'\n                                            ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_2,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_2));
    this._pipe_translate_0 = new import21.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.parentView.parentView.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._text_6,
      this._text_7
    ]
    ),[disposable_0]);
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import23.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_8:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('carTemplate.moderation.VALIDATE_IMAGE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_8,currVal_8))) {
      this.renderer.setText(this._text_5,currVal_8);
      this._expr_8 = currVal_8;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_2(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.parentView.parentView.parentView.parentView.context.approveModelPicture(this.parentView.parentView.context.$implicit)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
class View_CarTemplateModerateComponent10 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _el_3:any;
  _text_4:any;
  _text_5:any;
  /*private*/ _expr_6:any;
  _pipe_date_6_0:any;
  _map_8:any;
  _pipe_translate_0:import21.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import22.ViewContainer) {
    super(View_CarTemplateModerateComponent10,renderType_CarTemplateModerateComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_6 = import23.UNINITIALIZED;
    this._map_8 = import3.pureProxy2((p0:any,p1:any):{[key: string]:any} => {
      return {
        companyName: p0,
        createdDate: p1
      }
      ;
    });
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'span',new import3.InlineArray2(2,'class','eva-icons-container'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                                    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'i',new import3.InlineArray2(2,'class','eva-icon-time'),(null as any));
    this._el_3 = import3.createRenderElement(this.renderer,this._el_2,'span',new import3.InlineArray2(2,'class','-h6 cursive'),(null as any));
    this._text_4 = this.renderer.createText(this._el_3,'',(null as any));
    this._text_5 = this.renderer.createText(this._el_0,'\n                                                ',(null as any));
    this._pipe_date_6_0 = import3.pureProxy2((<View_CarTemplateModerateComponent0>this.parentView.parentView.parentView.parentView)._pipe_date_6.transform.bind((<View_CarTemplateModerateComponent0>this.parentView.parentView.parentView.parentView)._pipe_date_6));
    this._pipe_translate_0 = new import21.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.parentView.parentView.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._el_3,
      this._text_4,
      this._text_5
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import23.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_6:any = import3.inlineInterpolate(1,' ',valUnwrapper.unwrap(this._pipe_translate_0.transform('carTemplate.CREATED',this._map_8(this.parentView.parentView.context.$implicit.createdByCompany.companyName,valUnwrapper.unwrap(import3.castByValue(this._pipe_date_6_0,(<View_CarTemplateModerateComponent0>this.parentView.parentView.parentView.parentView)._pipe_date_6.transform)(this.parentView.parentView.context.$implicit.creationDate,'dd-MM-yyyy HH:mm'))))),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_6,currVal_6))) {
      this.renderer.setText(this._text_4,currVal_6);
      this._expr_6 = currVal_6;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_CarTemplateModerateComponent7 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _anchor_4:any;
  /*private*/ _vc_4:import22.ViewContainer;
  _TemplateRef_4_5:any;
  _NgIf_4_6:import28.Wrapper_NgIf;
  _text_5:any;
  _anchor_6:any;
  /*private*/ _vc_6:import22.ViewContainer;
  _TemplateRef_6_5:any;
  _NgIf_6_6:import28.Wrapper_NgIf;
  _text_7:any;
  _text_8:any;
  _el_9:any;
  _text_10:any;
  _el_11:any;
  _text_12:any;
  _anchor_13:any;
  /*private*/ _vc_13:import22.ViewContainer;
  _TemplateRef_13_5:any;
  _NgIf_13_6:import28.Wrapper_NgIf;
  _text_14:any;
  _text_15:any;
  _text_16:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import22.ViewContainer) {
    super(View_CarTemplateModerateComponent7,renderType_CarTemplateModerateComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                        ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','col-md-4'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                                            ',(null as any));
    this._anchor_4 = this.renderer.createTemplateAnchor(this._el_2,(null as any));
    this._vc_4 = new import22.ViewContainer(4,2,this,this._anchor_4);
    this._TemplateRef_4_5 = new import29.TemplateRef_(this,4,this._anchor_4);
    this._NgIf_4_6 = new import28.Wrapper_NgIf(this._vc_4.vcRef,this._TemplateRef_4_5);
    this._text_5 = this.renderer.createText(this._el_2,'\n\n                                            ',(null as any));
    this._anchor_6 = this.renderer.createTemplateAnchor(this._el_2,(null as any));
    this._vc_6 = new import22.ViewContainer(6,2,this,this._anchor_6);
    this._TemplateRef_6_5 = new import29.TemplateRef_(this,6,this._anchor_6);
    this._NgIf_6_6 = new import28.Wrapper_NgIf(this._vc_6.vcRef,this._TemplateRef_6_5);
    this._text_7 = this.renderer.createText(this._el_2,'\n                                        ',(null as any));
    this._text_8 = this.renderer.createText(this._el_0,'\n                                        ',(null as any));
    this._el_9 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','col-md-6 -right eva-3-mt-sm'),(null as any));
    this._text_10 = this.renderer.createText(this._el_9,'\n                                            ',(null as any));
    this._el_11 = import3.createRenderElement(this.renderer,this._el_9,'p',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_12 = this.renderer.createText(this._el_11,'\n                                                ',(null as any));
    this._anchor_13 = this.renderer.createTemplateAnchor(this._el_11,(null as any));
    this._vc_13 = new import22.ViewContainer(13,11,this,this._anchor_13);
    this._TemplateRef_13_5 = new import29.TemplateRef_(this,13,this._anchor_13);
    this._NgIf_13_6 = new import28.Wrapper_NgIf(this._vc_13.vcRef,this._TemplateRef_13_5);
    this._text_14 = this.renderer.createText(this._el_11,'\n                                            ',(null as any));
    this._text_15 = this.renderer.createText(this._el_9,'\n                                        ',(null as any));
    this._text_16 = this.renderer.createText(this._el_0,'\n                                    ',(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._anchor_4,
      this._text_5,
      this._anchor_6,
      this._text_7,
      this._text_8,
      this._el_9,
      this._text_10,
      this._el_11,
      this._text_12,
      this._anchor_13,
      this._text_14,
      this._text_15,
      this._text_16
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import29.TemplateRef) && (4 === requestNodeIndex))) { return this._TemplateRef_4_5; }
    if (((token === import30.NgIf) && (4 === requestNodeIndex))) { return this._NgIf_4_6.context; }
    if (((token === import29.TemplateRef) && (6 === requestNodeIndex))) { return this._TemplateRef_6_5; }
    if (((token === import30.NgIf) && (6 === requestNodeIndex))) { return this._NgIf_6_6.context; }
    if (((token === import29.TemplateRef) && (13 === requestNodeIndex))) { return this._TemplateRef_13_5; }
    if (((token === import30.NgIf) && (13 === requestNodeIndex))) { return this._NgIf_13_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_4_0_0:any = this.parentView.parentView.parentView.context.isModerationAllowed(this.parentView.context.$implicit);
    this._NgIf_4_6.check_ngIf(currVal_4_0_0,throwOnChange,false);
    this._NgIf_4_6.ngDoCheck(this,this._anchor_4,throwOnChange);
    const currVal_6_0_0:any = this.parentView.parentView.parentView.context.isImageModerationAllowed(this.parentView.context.$implicit);
    this._NgIf_6_6.check_ngIf(currVal_6_0_0,throwOnChange,false);
    this._NgIf_6_6.ngDoCheck(this,this._anchor_6,throwOnChange);
    const currVal_13_0_0:boolean = (!!this.parentView.context.$implicit.creationDate && !!this.parentView.context.$implicit.createdByCompany);
    this._NgIf_13_6.check_ngIf(currVal_13_0_0,throwOnChange,false);
    this._NgIf_13_6.ngDoCheck(this,this._anchor_13,throwOnChange);
    this._vc_4.detectChangesInNestedViews(throwOnChange);
    this._vc_6.detectChangesInNestedViews(throwOnChange);
    this._vc_13.detectChangesInNestedViews(throwOnChange);
  }
  destroyInternal():void {
    this._vc_4.destroyNestedViews();
    this._vc_6.destroyNestedViews();
    this._vc_13.destroyNestedViews();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 4)) { return new View_CarTemplateModerateComponent8(this.viewUtils,this,4,this._anchor_4,this._vc_4); }
    if ((nodeIndex == 6)) { return new View_CarTemplateModerateComponent9(this.viewUtils,this,6,this._anchor_6,this._vc_6); }
    if ((nodeIndex == 13)) { return new View_CarTemplateModerateComponent10(this.viewUtils,this,13,this._anchor_13,this._vc_13); }
    return (null as any);
  }
}
class View_CarTemplateModerateComponent4 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  compView_2:import1.AppView<import31.CarTemplateListCardComponent>;
  _CarTemplateListCardComponent_2_3:import32.Wrapper_CarTemplateListCardComponent;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _el_10:any;
  _el_11:any;
  _text_12:any;
  _text_13:any;
  _text_14:any;
  _el_15:any;
  _el_16:any;
  _text_17:any;
  _text_18:any;
  _text_19:any;
  _el_20:any;
  _el_21:any;
  _text_22:any;
  _text_23:any;
  _text_24:any;
  _el_25:any;
  _el_26:any;
  _text_27:any;
  _text_28:any;
  _text_29:any;
  _text_30:any;
  _el_31:any;
  _text_32:any;
  _el_33:any;
  _el_34:any;
  _text_35:any;
  _text_36:any;
  _text_37:any;
  _el_38:any;
  _el_39:any;
  _text_40:any;
  _text_41:any;
  _text_42:any;
  _el_43:any;
  _el_44:any;
  _text_45:any;
  _text_46:any;
  _text_47:any;
  _el_48:any;
  _el_49:any;
  _text_50:any;
  _text_51:any;
  _text_52:any;
  _text_53:any;
  _el_54:any;
  _text_55:any;
  _el_56:any;
  _text_57:any;
  _anchor_58:any;
  /*private*/ _vc_58:import22.ViewContainer;
  _TemplateRef_58_5:any;
  _NgIf_58_6:import28.Wrapper_NgIf;
  _text_59:any;
  _anchor_60:any;
  /*private*/ _vc_60:import22.ViewContainer;
  _TemplateRef_60_5:any;
  _NgIf_60_6:import28.Wrapper_NgIf;
  _text_61:any;
  _text_62:any;
  _text_63:any;
  _text_64:any;
  _anchor_65:any;
  /*private*/ _vc_65:import22.ViewContainer;
  _TemplateRef_65_5:any;
  _NgIf_65_6:import28.Wrapper_NgIf;
  _text_66:any;
  _text_67:any;
  _text_68:any;
  _map_80:any;
  /*private*/ _expr_81:any;
  _pipe_translate_0:import21.TranslatePipe;
  /*private*/ _expr_83:any;
  /*private*/ _expr_84:any;
  _pipe_translate_1:import21.TranslatePipe;
  /*private*/ _expr_86:any;
  /*private*/ _expr_87:any;
  _pipe_translate_2:import21.TranslatePipe;
  /*private*/ _expr_89:any;
  /*private*/ _expr_90:any;
  _pipe_translate_3:import21.TranslatePipe;
  /*private*/ _expr_92:any;
  /*private*/ _expr_93:any;
  _pipe_translate_4:import21.TranslatePipe;
  /*private*/ _expr_95:any;
  /*private*/ _expr_96:any;
  _pipe_translate_5:import21.TranslatePipe;
  /*private*/ _expr_98:any;
  /*private*/ _expr_99:any;
  _pipe_translate_6:import21.TranslatePipe;
  /*private*/ _expr_101:any;
  _pipe_translate_7:import21.TranslatePipe;
  /*private*/ _expr_103:any;
  _pipe_translate_8:import21.TranslatePipe;
  /*private*/ _expr_105:any;
  _pipe_translate_9:import21.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import22.ViewContainer) {
    super(View_CarTemplateModerateComponent4,renderType_CarTemplateModerateComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._map_80 = import3.pureProxy5((p0:any,p1:any,p2:any,p3:any,p4:any):{[key: string]:any} => {
      return {
        title: p0,
        status: p1,
        editable: p2,
        removable: p3,
        moderable: p4
      }
      ;
    });
    this._expr_81 = import23.UNINITIALIZED;
    this._expr_83 = import23.UNINITIALIZED;
    this._expr_84 = import23.UNINITIALIZED;
    this._expr_86 = import23.UNINITIALIZED;
    this._expr_87 = import23.UNINITIALIZED;
    this._expr_89 = import23.UNINITIALIZED;
    this._expr_90 = import23.UNINITIALIZED;
    this._expr_92 = import23.UNINITIALIZED;
    this._expr_93 = import23.UNINITIALIZED;
    this._expr_95 = import23.UNINITIALIZED;
    this._expr_96 = import23.UNINITIALIZED;
    this._expr_98 = import23.UNINITIALIZED;
    this._expr_99 = import23.UNINITIALIZED;
    this._expr_101 = import23.UNINITIALIZED;
    this._expr_103 = import23.UNINITIALIZED;
    this._expr_105 = import23.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                            ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'car-template-list-card',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_2 = new import32.View_CarTemplateListCardComponent0(this.viewUtils,this,2,this._el_2);
    this._CarTemplateListCardComponent_2_3 = new import32.Wrapper_CarTemplateListCardComponent(this.compView_2.ref);
    this._text_3 = this.renderer.createText((null as any),'\n                                ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','panel-body'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n                                    ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n                                        ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray2(2,'class','-md-4'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'\n                                            ',(null as any));
    this._el_10 = import3.createRenderElement(this.renderer,this._el_8,'p',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._el_11 = import3.createRenderElement(this.renderer,this._el_10,'span',new import3.InlineArray4(4,'class','car-label','qadata','brand'),(null as any));
    this._text_12 = this.renderer.createText(this._el_11,'',(null as any));
    this._text_13 = this.renderer.createText(this._el_10,'',(null as any));
    this._text_14 = this.renderer.createText(this._el_8,'\n                                            ',(null as any));
    this._el_15 = import3.createRenderElement(this.renderer,this._el_8,'p',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._el_16 = import3.createRenderElement(this.renderer,this._el_15,'span',new import3.InlineArray4(4,'class','car-label','qadata','model'),(null as any));
    this._text_17 = this.renderer.createText(this._el_16,'',(null as any));
    this._text_18 = this.renderer.createText(this._el_15,'',(null as any));
    this._text_19 = this.renderer.createText(this._el_8,'\n                                            ',(null as any));
    this._el_20 = import3.createRenderElement(this.renderer,this._el_8,'p',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._el_21 = import3.createRenderElement(this.renderer,this._el_20,'span',new import3.InlineArray4(4,'class','car-label','qadata','category'),(null as any));
    this._text_22 = this.renderer.createText(this._el_21,'',(null as any));
    this._text_23 = this.renderer.createText(this._el_20,'',(null as any));
    this._text_24 = this.renderer.createText(this._el_8,'\n                                            ',(null as any));
    this._el_25 = import3.createRenderElement(this.renderer,this._el_8,'p',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._el_26 = import3.createRenderElement(this.renderer,this._el_25,'span',new import3.InlineArray4(4,'class','car-label','qadata','type'),(null as any));
    this._text_27 = this.renderer.createText(this._el_26,'',(null as any));
    this._text_28 = this.renderer.createText(this._el_25,'',(null as any));
    this._text_29 = this.renderer.createText(this._el_8,'\n                                        ',(null as any));
    this._text_30 = this.renderer.createText(this._el_6,'\n                                        ',(null as any));
    this._el_31 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray2(2,'class','-md-4'),(null as any));
    this._text_32 = this.renderer.createText(this._el_31,'\n                                            ',(null as any));
    this._el_33 = import3.createRenderElement(this.renderer,this._el_31,'p',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._el_34 = import3.createRenderElement(this.renderer,this._el_33,'span',new import3.InlineArray4(4,'class','car-label','qadata','doors'),(null as any));
    this._text_35 = this.renderer.createText(this._el_34,'',(null as any));
    this._text_36 = this.renderer.createText(this._el_33,'',(null as any));
    this._text_37 = this.renderer.createText(this._el_31,'\n                                            ',(null as any));
    this._el_38 = import3.createRenderElement(this.renderer,this._el_31,'p',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._el_39 = import3.createRenderElement(this.renderer,this._el_38,'span',new import3.InlineArray4(4,'class','car-label','qadata','passengers'),(null as any));
    this._text_40 = this.renderer.createText(this._el_39,'',(null as any));
    this._text_41 = this.renderer.createText(this._el_38,'',(null as any));
    this._text_42 = this.renderer.createText(this._el_31,'\n                                            ',(null as any));
    this._el_43 = import3.createRenderElement(this.renderer,this._el_31,'p',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._el_44 = import3.createRenderElement(this.renderer,this._el_43,'span',new import3.InlineArray4(4,'class','car-label','qadata','ac'),(null as any));
    this._text_45 = this.renderer.createText(this._el_44,'',(null as any));
    this._text_46 = this.renderer.createText(this._el_43,'',(null as any));
    this._text_47 = this.renderer.createText(this._el_31,'\n                                            ',(null as any));
    this._el_48 = import3.createRenderElement(this.renderer,this._el_31,'p',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._el_49 = import3.createRenderElement(this.renderer,this._el_48,'span',new import3.InlineArray4(4,'class','car-label','qadata','transmission'),(null as any));
    this._text_50 = this.renderer.createText(this._el_49,'',(null as any));
    this._text_51 = this.renderer.createText(this._el_48,'',(null as any));
    this._text_52 = this.renderer.createText(this._el_31,'\n                                        ',(null as any));
    this._text_53 = this.renderer.createText(this._el_6,'\n                                        ',(null as any));
    this._el_54 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray2(2,'class','-md-4'),(null as any));
    this._text_55 = this.renderer.createText(this._el_54,'\n                                            ',(null as any));
    this._el_56 = import3.createRenderElement(this.renderer,this._el_54,'div',new import3.InlineArray2(2,'class','car-thumbnail-list'),(null as any));
    this._text_57 = this.renderer.createText(this._el_56,'\n                                                ',(null as any));
    this._anchor_58 = this.renderer.createTemplateAnchor(this._el_56,(null as any));
    this._vc_58 = new import22.ViewContainer(58,56,this,this._anchor_58);
    this._TemplateRef_58_5 = new import29.TemplateRef_(this,58,this._anchor_58);
    this._NgIf_58_6 = new import28.Wrapper_NgIf(this._vc_58.vcRef,this._TemplateRef_58_5);
    this._text_59 = this.renderer.createText(this._el_56,'\n                                                ',(null as any));
    this._anchor_60 = this.renderer.createTemplateAnchor(this._el_56,(null as any));
    this._vc_60 = new import22.ViewContainer(60,56,this,this._anchor_60);
    this._TemplateRef_60_5 = new import29.TemplateRef_(this,60,this._anchor_60);
    this._NgIf_60_6 = new import28.Wrapper_NgIf(this._vc_60.vcRef,this._TemplateRef_60_5);
    this._text_61 = this.renderer.createText(this._el_56,'\n\n                                            ',(null as any));
    this._text_62 = this.renderer.createText(this._el_54,'\n                                        ',(null as any));
    this._text_63 = this.renderer.createText(this._el_6,'\n                                    ',(null as any));
    this._text_64 = this.renderer.createText(this._el_4,'\n                                    ',(null as any));
    this._anchor_65 = this.renderer.createTemplateAnchor(this._el_4,(null as any));
    this._vc_65 = new import22.ViewContainer(65,4,this,this._anchor_65);
    this._TemplateRef_65_5 = new import29.TemplateRef_(this,65,this._anchor_65);
    this._NgIf_65_6 = new import28.Wrapper_NgIf(this._vc_65.vcRef,this._TemplateRef_65_5);
    this._text_66 = this.renderer.createText(this._el_4,'\n                                ',(null as any));
    this._text_67 = this.renderer.createText((null as any),'\n                            ',(null as any));
    this.compView_2.create(this._CarTemplateListCardComponent_2_3.context);
    this._text_68 = this.renderer.createText(this._el_0,'\n                        ',(null as any));
    this._pipe_translate_0 = new import21.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_1 = new import21.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_2 = new import21.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_3 = new import21.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_4 = new import21.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_5 = new import21.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_6 = new import21.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_7 = new import21.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_8 = new import21.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_9 = new import21.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._el_10,
      this._el_11,
      this._text_12,
      this._text_13,
      this._text_14,
      this._el_15,
      this._el_16,
      this._text_17,
      this._text_18,
      this._text_19,
      this._el_20,
      this._el_21,
      this._text_22,
      this._text_23,
      this._text_24,
      this._el_25,
      this._el_26,
      this._text_27,
      this._text_28,
      this._text_29,
      this._text_30,
      this._el_31,
      this._text_32,
      this._el_33,
      this._el_34,
      this._text_35,
      this._text_36,
      this._text_37,
      this._el_38,
      this._el_39,
      this._text_40,
      this._text_41,
      this._text_42,
      this._el_43,
      this._el_44,
      this._text_45,
      this._text_46,
      this._text_47,
      this._el_48,
      this._el_49,
      this._text_50,
      this._text_51,
      this._text_52,
      this._text_53,
      this._el_54,
      this._text_55,
      this._el_56,
      this._text_57,
      this._anchor_58,
      this._text_59,
      this._anchor_60,
      this._text_61,
      this._text_62,
      this._text_63,
      this._text_64,
      this._anchor_65,
      this._text_66,
      this._text_67,
      this._text_68
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import29.TemplateRef) && (58 === requestNodeIndex))) { return this._TemplateRef_58_5; }
    if (((token === import30.NgIf) && (58 === requestNodeIndex))) { return this._NgIf_58_6.context; }
    if (((token === import29.TemplateRef) && (60 === requestNodeIndex))) { return this._TemplateRef_60_5; }
    if (((token === import30.NgIf) && (60 === requestNodeIndex))) { return this._NgIf_60_6.context; }
    if (((token === import29.TemplateRef) && (65 === requestNodeIndex))) { return this._TemplateRef_65_5; }
    if (((token === import30.NgIf) && (65 === requestNodeIndex))) { return this._NgIf_65_6.context; }
    if (((token === import31.CarTemplateListCardComponent) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 67)))) { return this._CarTemplateListCardComponent_2_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import23.ValueUnwrapper();
    const currVal_2_0_0:any = this._map_80(((((this.context.$implicit.carModel == null)? (null as any): this.context.$implicit.carModel.brand) + '-') + ((this.context.$implicit.carModel == null)? (null as any): this.context.$implicit.carModel.model)),this.context.$implicit.approvalStatus,false,false,true);
    this._CarTemplateListCardComponent_2_3.check_listCard(currVal_2_0_0,throwOnChange,false);
    const currVal_2_0_1:any = 200;
    this._CarTemplateListCardComponent_2_3.check_cardHeight(currVal_2_0_1,throwOnChange,false);
    this._CarTemplateListCardComponent_2_3.ngDoCheck(this,this._el_2,throwOnChange);
    const currVal_58_0_0:boolean = ((!this.parentView.parentView.context.showAuxPicture(this.context.$implicit) && !!((this.context.$implicit.carModel == null)? (null as any): this.context.$implicit.carModel.picture)) && ((this.context.$implicit.carModel == null)? (null as any): this.context.$implicit.carModel.picture.url));
    this._NgIf_58_6.check_ngIf(currVal_58_0_0,throwOnChange,false);
    this._NgIf_58_6.ngDoCheck(this,this._anchor_58,throwOnChange);
    const currVal_60_0_0:any = ((this.parentView.parentView.context.showAuxPicture(this.context.$implicit) && !!((this.context.$implicit.carModel == null)? (null as any): this.context.$implicit.carModel.auxPicture)) && ((this.context.$implicit.carModel == null)? (null as any): this.context.$implicit.carModel.auxPicture.url));
    this._NgIf_60_6.check_ngIf(currVal_60_0_0,throwOnChange,false);
    this._NgIf_60_6.ngDoCheck(this,this._anchor_60,throwOnChange);
    const currVal_65_0_0:any = (this.parentView.parentView.context.isModerationAllowed(this.context.$implicit) || this.parentView.parentView.context.isImageModerationAllowed(this.context.$implicit));
    this._NgIf_65_6.check_ngIf(currVal_65_0_0,throwOnChange,false);
    this._NgIf_65_6.ngDoCheck(this,this._anchor_65,throwOnChange);
    this._vc_58.detectChangesInNestedViews(throwOnChange);
    this._vc_60.detectChangesInNestedViews(throwOnChange);
    this._vc_65.detectChangesInNestedViews(throwOnChange);
    valUnwrapper.reset();
    const currVal_81:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('carTemplate.BRAND')),':');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_81,currVal_81))) {
      this.renderer.setText(this._text_12,currVal_81);
      this._expr_81 = currVal_81;
    }
    const currVal_83:any = import3.inlineInterpolate(1,'',((this.context.$implicit.carModel == null)? (null as any): this.context.$implicit.carModel.brand),'');
    if (import3.checkBinding(throwOnChange,this._expr_83,currVal_83)) {
      this.renderer.setText(this._text_13,currVal_83);
      this._expr_83 = currVal_83;
    }
    valUnwrapper.reset();
    const currVal_84:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform('carTemplate.MODEL')),':');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_84,currVal_84))) {
      this.renderer.setText(this._text_17,currVal_84);
      this._expr_84 = currVal_84;
    }
    const currVal_86:any = import3.inlineInterpolate(1,'',((this.context.$implicit.carModel == null)? (null as any): this.context.$implicit.carModel.model),'');
    if (import3.checkBinding(throwOnChange,this._expr_86,currVal_86)) {
      this.renderer.setText(this._text_18,currVal_86);
      this._expr_86 = currVal_86;
    }
    valUnwrapper.reset();
    const currVal_87:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_2.transform('carTemplate.CATEGORY')),':');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_87,currVal_87))) {
      this.renderer.setText(this._text_22,currVal_87);
      this._expr_87 = currVal_87;
    }
    const currVal_89:any = import3.inlineInterpolate(1,'',((this.context.$implicit.carModel == null)? (null as any): this.context.$implicit.carModel.category),'');
    if (import3.checkBinding(throwOnChange,this._expr_89,currVal_89)) {
      this.renderer.setText(this._text_23,currVal_89);
      this._expr_89 = currVal_89;
    }
    valUnwrapper.reset();
    const currVal_90:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_3.transform('carTemplate.TYPE')),':');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_90,currVal_90))) {
      this.renderer.setText(this._text_27,currVal_90);
      this._expr_90 = currVal_90;
    }
    const currVal_92:any = import3.inlineInterpolate(1,'',((this.context.$implicit.carModel == null)? (null as any): this.context.$implicit.carModel.type),'');
    if (import3.checkBinding(throwOnChange,this._expr_92,currVal_92)) {
      this.renderer.setText(this._text_28,currVal_92);
      this._expr_92 = currVal_92;
    }
    valUnwrapper.reset();
    const currVal_93:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_4.transform('carTemplate.DOORS')),':');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_93,currVal_93))) {
      this.renderer.setText(this._text_35,currVal_93);
      this._expr_93 = currVal_93;
    }
    const currVal_95:any = import3.inlineInterpolate(1,'',this.context.$implicit.doors,'');
    if (import3.checkBinding(throwOnChange,this._expr_95,currVal_95)) {
      this.renderer.setText(this._text_36,currVal_95);
      this._expr_95 = currVal_95;
    }
    valUnwrapper.reset();
    const currVal_96:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_5.transform('carTemplate.PASSENGERS')),':');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_96,currVal_96))) {
      this.renderer.setText(this._text_40,currVal_96);
      this._expr_96 = currVal_96;
    }
    const currVal_98:any = import3.inlineInterpolate(1,'',this.context.$implicit.passengers,'');
    if (import3.checkBinding(throwOnChange,this._expr_98,currVal_98)) {
      this.renderer.setText(this._text_41,currVal_98);
      this._expr_98 = currVal_98;
    }
    valUnwrapper.reset();
    const currVal_99:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_6.transform('carTemplate.AC')),':');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_99,currVal_99))) {
      this.renderer.setText(this._text_45,currVal_99);
      this._expr_99 = currVal_99;
    }
    valUnwrapper.reset();
    const currVal_101:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_7.transform(('common.' + this.context.$implicit.airConditioning))),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_101,currVal_101))) {
      this.renderer.setText(this._text_46,currVal_101);
      this._expr_101 = currVal_101;
    }
    valUnwrapper.reset();
    const currVal_103:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_8.transform('carTemplate.TRANSMISSION')),':');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_103,currVal_103))) {
      this.renderer.setText(this._text_50,currVal_103);
      this._expr_103 = currVal_103;
    }
    valUnwrapper.reset();
    const currVal_105:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_9.transform(('fleet.TRANS_' + this.context.$implicit.transmission))),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_105,currVal_105))) {
      this.renderer.setText(this._text_51,currVal_105);
      this._expr_105 = currVal_105;
    }
    this.compView_2.internalDetectChanges(throwOnChange);
    if (!throwOnChange) { this._CarTemplateListCardComponent_2_3.context.ngAfterViewChecked(); }
  }
  destroyInternal():void {
    this._vc_58.destroyNestedViews();
    this._vc_60.destroyNestedViews();
    this._vc_65.destroyNestedViews();
    this.compView_2.destroy();
    this._CarTemplateListCardComponent_2_3.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
    this._pipe_translate_2.ngOnDestroy();
    this._pipe_translate_3.ngOnDestroy();
    this._pipe_translate_4.ngOnDestroy();
    this._pipe_translate_5.ngOnDestroy();
    this._pipe_translate_6.ngOnDestroy();
    this._pipe_translate_7.ngOnDestroy();
    this._pipe_translate_8.ngOnDestroy();
    this._pipe_translate_9.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  visitProjectableNodesInternal(nodeIndex:number,ngContentIndex:number,cb:any,ctx:any):void {
    if (((nodeIndex == 2) && (ngContentIndex == 0))) {
      cb(this._text_3,ctx);
      cb(this._el_4,ctx);
      cb(this._text_67,ctx);
    }
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 58)) { return new View_CarTemplateModerateComponent5(this.viewUtils,this,58,this._anchor_58,this._vc_58); }
    if ((nodeIndex == 60)) { return new View_CarTemplateModerateComponent6(this.viewUtils,this,60,this._anchor_60,this._vc_60); }
    if ((nodeIndex == 65)) { return new View_CarTemplateModerateComponent7(this.viewUtils,this,65,this._anchor_65,this._vc_65); }
    return (null as any);
  }
}
class View_CarTemplateModerateComponent3 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _anchor_2:any;
  /*private*/ _vc_2:import22.ViewContainer;
  _TemplateRef_2_5:any;
  _NgFor_2_6:import33.Wrapper_NgFor;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  compView_6:import1.AppView<import34.EvaPagerComponent>;
  _EvaPagerComponent_6_3:import35.Wrapper_EvaPagerComponent;
  _text_7:any;
  _text_8:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import22.ViewContainer) {
    super(View_CarTemplateModerateComponent3,renderType_CarTemplateModerateComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                        ',(null as any));
    this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_2 = new import22.ViewContainer(2,0,this,this._anchor_2);
    this._TemplateRef_2_5 = new import29.TemplateRef_(this,2,this._anchor_2);
    this._NgFor_2_6 = new import33.Wrapper_NgFor(this._vc_2.vcRef,this._TemplateRef_2_5,this.parentView.parentView.injectorGet(import36.IterableDiffers,this.parentView.parentIndex),this.parentView.ref);
    this._text_3 = this.renderer.createText(this._el_0,'\n                        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','eva-row -m-top-lg'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n                            ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'eva-pager',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_6 = new import35.View_EvaPagerComponent0(this.viewUtils,this,6,this._el_6);
    this._EvaPagerComponent_6_3 = new import35.Wrapper_EvaPagerComponent();
    this.compView_6.create(this._EvaPagerComponent_6_3.context);
    this._text_7 = this.renderer.createText(this._el_4,'\n                        ',(null as any));
    this._text_8 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_6,new import3.InlineArray2(2,'pageChanged',(null as any)),this.eventHandler(this.handleEvent_6));
    this._EvaPagerComponent_6_3.subscribe(this,this.eventHandler(this.handleEvent_6),true);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._anchor_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._text_8
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import29.TemplateRef) && (2 === requestNodeIndex))) { return this._TemplateRef_2_5; }
    if (((token === import37.NgFor) && (2 === requestNodeIndex))) { return this._NgFor_2_6.context; }
    if (((token === import34.EvaPagerComponent) && (6 === requestNodeIndex))) { return this._EvaPagerComponent_6_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = this.parentView.context.page.pageItems;
    this._NgFor_2_6.check_ngForOf(currVal_2_0_0,throwOnChange,false);
    this._NgFor_2_6.ngDoCheck(this,this._anchor_2,throwOnChange);
    const currVal_6_0_0:any = this.parentView.context.page;
    this._EvaPagerComponent_6_3.check_config(currVal_6_0_0,throwOnChange,false);
    this._EvaPagerComponent_6_3.ngDoCheck(this,this._el_6,throwOnChange);
    this._vc_2.detectChangesInNestedViews(throwOnChange);
    this.compView_6.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this._vc_2.destroyNestedViews();
    this.compView_6.destroy();
    this._EvaPagerComponent_6_3.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 2)) { return new View_CarTemplateModerateComponent4(this.viewUtils,this,2,this._anchor_2,this._vc_2); }
    return (null as any);
  }
  handleEvent_6(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'pageChanged')) {
      const pd_sub_0:any = ((<any>this.parentView.context.onChangePage($event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
class View_CarTemplateModerateComponent11 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _text_10:any;
  _text_11:any;
  _text_12:any;
  /*private*/ _expr_13:any;
  _pipe_translate_0:import21.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import22.ViewContainer) {
    super(View_CarTemplateModerateComponent11,renderType_CarTemplateModerateComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_13 = import23.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-mb-xlg empty-state-rate'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                        ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray4(4,'class','empty-state-image col -sm-12','qadata','emptyState'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                            ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','heading-example col -sm-12'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n                                ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'img',new import3.InlineArray2(2,'src','assets/noresults-image.png'),(null as any));
    this._text_7 = this.renderer.createText(this._el_4,'\n                                ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_4,'h3',new import3.InlineArray2(2,'class','eva-3-h3'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'',(null as any));
    this._text_10 = this.renderer.createText(this._el_4,'\n                            ',(null as any));
    this._text_11 = this.renderer.createText(this._el_2,'\n                        ',(null as any));
    this._text_12 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._pipe_translate_0 = new import21.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._text_10,
      this._text_11,
      this._text_12
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import23.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_13:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('common.NO_RESULTS_FOUND')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_13,currVal_13))) {
      this.renderer.setText(this._text_9,currVal_13);
      this._expr_13 = currVal_13;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
var renderType_CarTemplateModerateComponent:import2.RenderComponentType = import3.createRenderComponentType('',0,import4.ViewEncapsulation.None,styles_CarTemplateModerateComponent,{});
export class View_CarTemplateModerateComponent0 extends import1.AppView<import0.CarTemplateModerateComponent> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _el_10:any;
  _text_11:any;
  _el_12:any;
  _text_13:any;
  _text_14:any;
  _el_15:any;
  _text_16:any;
  _text_17:any;
  _text_18:any;
  _text_19:any;
  _el_20:any;
  _text_21:any;
  _el_22:any;
  _text_23:any;
  _el_24:any;
  _text_25:any;
  _text_26:any;
  _el_27:any;
  _text_28:any;
  _el_29:any;
  _text_30:any;
  _el_31:any;
  _text_32:any;
  _el_33:any;
  _text_34:any;
  _text_35:any;
  _el_36:any;
  _text_37:any;
  _el_38:any;
  _SelectControlValueAccessor_38_3:import19.Wrapper_SelectControlValueAccessor;
  _NG_VALUE_ACCESSOR_38_4:any[];
  _NgModel_38_5:import38.Wrapper_NgModel;
  _NgControl_38_6:any;
  _NgControlStatus_38_7:import39.Wrapper_NgControlStatus;
  _text_39:any;
  _anchor_40:any;
  /*private*/ _vc_40:import22.ViewContainer;
  _TemplateRef_40_5:any;
  _NgFor_40_6:import33.Wrapper_NgFor;
  _text_41:any;
  _text_42:any;
  _text_43:any;
  _text_44:any;
  _text_45:any;
  _el_46:any;
  _text_47:any;
  _el_48:any;
  _text_49:any;
  _el_50:any;
  _text_51:any;
  _text_52:any;
  _el_53:any;
  _text_54:any;
  _el_55:any;
  _SelectControlValueAccessor_55_3:import19.Wrapper_SelectControlValueAccessor;
  _NG_VALUE_ACCESSOR_55_4:any[];
  _NgModel_55_5:import38.Wrapper_NgModel;
  _NgControl_55_6:any;
  _NgControlStatus_55_7:import39.Wrapper_NgControlStatus;
  _text_56:any;
  _el_57:any;
  _NgSelectOption_57_3:import19.Wrapper_NgSelectOption;
  _NgSelectMultipleOption_57_4:import20.Wrapper_NgSelectMultipleOption;
  _text_58:any;
  _text_59:any;
  _anchor_60:any;
  /*private*/ _vc_60:import22.ViewContainer;
  _TemplateRef_60_5:any;
  _NgFor_60_6:import33.Wrapper_NgFor;
  _text_61:any;
  _text_62:any;
  _text_63:any;
  _text_64:any;
  _text_65:any;
  _text_66:any;
  _text_67:any;
  _text_68:any;
  _el_69:any;
  _text_70:any;
  _anchor_71:any;
  /*private*/ _vc_71:import22.ViewContainer;
  _TemplateRef_71_5:any;
  _NgIf_71_6:import28.Wrapper_NgIf;
  _text_72:any;
  _anchor_73:any;
  /*private*/ _vc_73:import22.ViewContainer;
  _TemplateRef_73_5:any;
  _NgIf_73_6:import28.Wrapper_NgIf;
  _text_74:any;
  _text_75:any;
  _text_76:any;
  _text_77:any;
  _text_78:any;
  _text_79:any;
  /*private*/ _expr_104:any;
  _pipe_translate_0:import21.TranslatePipe;
  /*private*/ _expr_106:any;
  _pipe_translate_1:import21.TranslatePipe;
  /*private*/ _expr_108:any;
  _pipe_translate_2:import21.TranslatePipe;
  /*private*/ _expr_110:any;
  _pipe_translate_3:import21.TranslatePipe;
  /*private*/ _expr_112:any;
  _pipe_translate_4:import21.TranslatePipe;
  /*private*/ _expr_114:any;
  _pipe_translate_5:import21.TranslatePipe;
  _pipe_date_6:import40.DatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_CarTemplateModerateComponent0,renderType_CarTemplateModerateComponent,import6.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_104 = import23.UNINITIALIZED;
    this._expr_106 = import23.UNINITIALIZED;
    this._expr_108 = import23.UNINITIALIZED;
    this._expr_110 = import23.UNINITIALIZED;
    this._expr_112 = import23.UNINITIALIZED;
    this._expr_114 = import23.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray2(2,'class','eva-slide -up -start'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','container-fluid whitesmoke-section'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','eva-container'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n            ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'div',new import3.InlineArray2(2,'class','eva-grid'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-mb-lg'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'\n                    ',(null as any));
    this._el_10 = import3.createRenderElement(this.renderer,this._el_8,'div',new import3.InlineArray2(2,'class','-eva-3-mt-md'),(null as any));
    this._text_11 = this.renderer.createText(this._el_10,'\n                        ',(null as any));
    this._el_12 = import3.createRenderElement(this.renderer,this._el_10,'span',new import3.InlineArray2(2,'class','-h2 -eva-3-ml-xsm'),(null as any));
    this._text_13 = this.renderer.createText(this._el_12,'',(null as any));
    this._text_14 = this.renderer.createText(this._el_10,'\n                        ',(null as any));
    this._el_15 = import3.createRenderElement(this.renderer,this._el_10,'p',new import3.InlineArray4(4,'class','-h6 -eva-3-tc-gray-2 -eva-3-mt-sm -eva-3-ml-xsm','style','line-height: 16px;'),(null as any));
    this._text_16 = this.renderer.createText(this._el_15,'',(null as any));
    this._text_17 = this.renderer.createText(this._el_10,'\n                    ',(null as any));
    this._text_18 = this.renderer.createText(this._el_8,'\n                ',(null as any));
    this._text_19 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._el_20 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray4(4,'class','eva-3-row -eva-3-mt-lg','qadata','page_actions'),(null as any));
    this._text_21 = this.renderer.createText(this._el_20,'\n                    ',(null as any));
    this._el_22 = import3.createRenderElement(this.renderer,this._el_20,'div',new import3.InlineArray2(2,'class','white-container reset-styles'),(null as any));
    this._text_23 = this.renderer.createText(this._el_22,'\n                        ',(null as any));
    this._el_24 = import3.createRenderElement(this.renderer,this._el_22,'h4',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_25 = this.renderer.createText(this._el_24,'',(null as any));
    this._text_26 = this.renderer.createText(this._el_22,'\n                        ',(null as any));
    this._el_27 = import3.createRenderElement(this.renderer,this._el_22,'div',new import3.InlineArray2(2,'class','eva-row'),(null as any));
    this._text_28 = this.renderer.createText(this._el_27,'\n                            ',(null as any));
    this._el_29 = import3.createRenderElement(this.renderer,this._el_27,'div',new import3.InlineArray2(2,'class','col -md-3'),(null as any));
    this._text_30 = this.renderer.createText(this._el_29,'\n                                ',(null as any));
    this._el_31 = import3.createRenderElement(this.renderer,this._el_29,'div',new import3.InlineArray2(2,'class','eva-select -md'),(null as any));
    this._text_32 = this.renderer.createText(this._el_31,'\n                                    ',(null as any));
    this._el_33 = import3.createRenderElement(this.renderer,this._el_31,'label',new import3.InlineArray2(2,'for','select-approval_status'),(null as any));
    this._text_34 = this.renderer.createText(this._el_33,'',(null as any));
    this._text_35 = this.renderer.createText(this._el_31,'\n                                    ',(null as any));
    this._el_36 = import3.createRenderElement(this.renderer,this._el_31,'div',new import3.InlineArray2(2,'class','select-container'),(null as any));
    this._text_37 = this.renderer.createText(this._el_36,'\n                                        ',(null as any));
    this._el_38 = import3.createRenderElement(this.renderer,this._el_36,'select',new import3.InlineArray4(4,'class','select-tag','id','select-approval_status'),(null as any));
    this._SelectControlValueAccessor_38_3 = new import19.Wrapper_SelectControlValueAccessor(this.renderer,new import24.ElementRef(this._el_38));
    this._NG_VALUE_ACCESSOR_38_4 = [this._SelectControlValueAccessor_38_3.context];
    this._NgModel_38_5 = new import38.Wrapper_NgModel((null as any),(null as any),(null as any),this._NG_VALUE_ACCESSOR_38_4);
    this._NgControl_38_6 = this._NgModel_38_5.context;
    this._NgControlStatus_38_7 = new import39.Wrapper_NgControlStatus(this._NgControl_38_6);
    this._text_39 = this.renderer.createText(this._el_38,'\n                                            ',(null as any));
    this._anchor_40 = this.renderer.createTemplateAnchor(this._el_38,(null as any));
    this._vc_40 = new import22.ViewContainer(40,38,this,this._anchor_40);
    this._TemplateRef_40_5 = new import29.TemplateRef_(this,40,this._anchor_40);
    this._NgFor_40_6 = new import33.Wrapper_NgFor(this._vc_40.vcRef,this._TemplateRef_40_5,this.parentView.injectorGet(import36.IterableDiffers,this.parentIndex),this.ref);
    this._text_41 = this.renderer.createText(this._el_38,'\n                                        ',(null as any));
    this._text_42 = this.renderer.createText(this._el_36,'\n                                    ',(null as any));
    this._text_43 = this.renderer.createText(this._el_31,'\n                                ',(null as any));
    this._text_44 = this.renderer.createText(this._el_29,'\n                            ',(null as any));
    this._text_45 = this.renderer.createText(this._el_27,'\n                            ',(null as any));
    this._el_46 = import3.createRenderElement(this.renderer,this._el_27,'div',new import3.InlineArray2(2,'class','col -md-3'),(null as any));
    this._text_47 = this.renderer.createText(this._el_46,'\n                                ',(null as any));
    this._el_48 = import3.createRenderElement(this.renderer,this._el_46,'div',new import3.InlineArray2(2,'class','eva-select -md'),(null as any));
    this._text_49 = this.renderer.createText(this._el_48,'\n                                    ',(null as any));
    this._el_50 = import3.createRenderElement(this.renderer,this._el_48,'label',new import3.InlineArray2(2,'for','select-country'),(null as any));
    this._text_51 = this.renderer.createText(this._el_50,'',(null as any));
    this._text_52 = this.renderer.createText(this._el_48,'\n                                    ',(null as any));
    this._el_53 = import3.createRenderElement(this.renderer,this._el_48,'div',new import3.InlineArray2(2,'class','select-container'),(null as any));
    this._text_54 = this.renderer.createText(this._el_53,'\n                                        ',(null as any));
    this._el_55 = import3.createRenderElement(this.renderer,this._el_53,'select',new import3.InlineArray4(4,'class','select-tag','id','select-country'),(null as any));
    this._SelectControlValueAccessor_55_3 = new import19.Wrapper_SelectControlValueAccessor(this.renderer,new import24.ElementRef(this._el_55));
    this._NG_VALUE_ACCESSOR_55_4 = [this._SelectControlValueAccessor_55_3.context];
    this._NgModel_55_5 = new import38.Wrapper_NgModel((null as any),(null as any),(null as any),this._NG_VALUE_ACCESSOR_55_4);
    this._NgControl_55_6 = this._NgModel_55_5.context;
    this._NgControlStatus_55_7 = new import39.Wrapper_NgControlStatus(this._NgControl_55_6);
    this._text_56 = this.renderer.createText(this._el_55,'\n                                            ',(null as any));
    this._el_57 = import3.createRenderElement(this.renderer,this._el_55,'option',new import3.InlineArray2(2,'value',''),(null as any));
    this._NgSelectOption_57_3 = new import19.Wrapper_NgSelectOption(new import24.ElementRef(this._el_57),this.renderer,this._SelectControlValueAccessor_55_3.context);
    this._NgSelectMultipleOption_57_4 = new import20.Wrapper_NgSelectMultipleOption(new import24.ElementRef(this._el_57),this.renderer,(null as any));
    this._text_58 = this.renderer.createText(this._el_57,'',(null as any));
    this._text_59 = this.renderer.createText(this._el_55,'\n                                            ',(null as any));
    this._anchor_60 = this.renderer.createTemplateAnchor(this._el_55,(null as any));
    this._vc_60 = new import22.ViewContainer(60,55,this,this._anchor_60);
    this._TemplateRef_60_5 = new import29.TemplateRef_(this,60,this._anchor_60);
    this._NgFor_60_6 = new import33.Wrapper_NgFor(this._vc_60.vcRef,this._TemplateRef_60_5,this.parentView.injectorGet(import36.IterableDiffers,this.parentIndex),this.ref);
    this._text_61 = this.renderer.createText(this._el_55,'\n                                        ',(null as any));
    this._text_62 = this.renderer.createText(this._el_53,'\n                                    ',(null as any));
    this._text_63 = this.renderer.createText(this._el_48,'\n                                ',(null as any));
    this._text_64 = this.renderer.createText(this._el_46,'\n                            ',(null as any));
    this._text_65 = this.renderer.createText(this._el_27,'\n                        ',(null as any));
    this._text_66 = this.renderer.createText(this._el_22,'\n                    ',(null as any));
    this._text_67 = this.renderer.createText(this._el_20,'\n                ',(null as any));
    this._text_68 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._el_69 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray2(2,'class','eva-row -m-top-lg'),(null as any));
    this._text_70 = this.renderer.createText(this._el_69,'\n                    ',(null as any));
    this._anchor_71 = this.renderer.createTemplateAnchor(this._el_69,(null as any));
    this._vc_71 = new import22.ViewContainer(71,69,this,this._anchor_71);
    this._TemplateRef_71_5 = new import29.TemplateRef_(this,71,this._anchor_71);
    this._NgIf_71_6 = new import28.Wrapper_NgIf(this._vc_71.vcRef,this._TemplateRef_71_5);
    this._text_72 = this.renderer.createText(this._el_69,'\n                    ',(null as any));
    this._anchor_73 = this.renderer.createTemplateAnchor(this._el_69,(null as any));
    this._vc_73 = new import22.ViewContainer(73,69,this,this._anchor_73);
    this._TemplateRef_73_5 = new import29.TemplateRef_(this,73,this._anchor_73);
    this._NgIf_73_6 = new import28.Wrapper_NgIf(this._vc_73.vcRef,this._TemplateRef_73_5);
    this._text_74 = this.renderer.createText(this._el_69,'\n                ',(null as any));
    this._text_75 = this.renderer.createText(this._el_6,'\n            ',(null as any));
    this._text_76 = this.renderer.createText(this._el_4,'\n        ',(null as any));
    this._text_77 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._text_78 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._text_79 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this._pipe_translate_0 = new import21.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_1 = new import21.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_2 = new import21.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_3 = new import21.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.ref);
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_38,new import3.InlineArray8(6,'change',(null as any),'ngModelChange',(null as any),'blur',(null as any)),this.eventHandler(this.handleEvent_38));
    this._NgModel_38_5.subscribe(this,this.eventHandler(this.handleEvent_38),true);
    this._pipe_translate_4 = new import21.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.ref);
    var disposable_1:Function = import3.subscribeToRenderElement(this,this._el_55,new import3.InlineArray8(6,'change',(null as any),'ngModelChange',(null as any),'blur',(null as any)),this.eventHandler(this.handleEvent_55));
    this._NgModel_55_5.subscribe(this,this.eventHandler(this.handleEvent_55),true);
    this._pipe_translate_5 = new import21.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.ref);
    this._pipe_date_6 = new import40.DatePipe(this.parentView.injectorGet(import41.LOCALE_ID,this.parentIndex));
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._text_14,
      this._el_15,
      this._text_16,
      this._text_17,
      this._text_18,
      this._text_19,
      this._el_20,
      this._text_21,
      this._el_22,
      this._text_23,
      this._el_24,
      this._text_25,
      this._text_26,
      this._el_27,
      this._text_28,
      this._el_29,
      this._text_30,
      this._el_31,
      this._text_32,
      this._el_33,
      this._text_34,
      this._text_35,
      this._el_36,
      this._text_37,
      this._el_38,
      this._text_39,
      this._anchor_40,
      this._text_41,
      this._text_42,
      this._text_43,
      this._text_44,
      this._text_45,
      this._el_46,
      this._text_47,
      this._el_48,
      this._text_49,
      this._el_50,
      this._text_51,
      this._text_52,
      this._el_53,
      this._text_54,
      this._el_55,
      this._text_56,
      this._el_57,
      this._text_58,
      this._text_59,
      this._anchor_60,
      this._text_61,
      this._text_62,
      this._text_63,
      this._text_64,
      this._text_65,
      this._text_66,
      this._text_67,
      this._text_68,
      this._el_69,
      this._text_70,
      this._anchor_71,
      this._text_72,
      this._anchor_73,
      this._text_74,
      this._text_75,
      this._text_76,
      this._text_77,
      this._text_78,
      this._text_79
    ]
    ),[
      disposable_0,
      disposable_1
    ]
    );
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import29.TemplateRef) && (40 === requestNodeIndex))) { return this._TemplateRef_40_5; }
    if (((token === import37.NgFor) && (40 === requestNodeIndex))) { return this._NgFor_40_6.context; }
    if (((token === import25.SelectControlValueAccessor) && ((38 <= requestNodeIndex) && (requestNodeIndex <= 41)))) { return this._SelectControlValueAccessor_38_3.context; }
    if (((token === import42.NG_VALUE_ACCESSOR) && ((38 <= requestNodeIndex) && (requestNodeIndex <= 41)))) { return this._NG_VALUE_ACCESSOR_38_4; }
    if (((token === import43.NgModel) && ((38 <= requestNodeIndex) && (requestNodeIndex <= 41)))) { return this._NgModel_38_5.context; }
    if (((token === import44.NgControl) && ((38 <= requestNodeIndex) && (requestNodeIndex <= 41)))) { return this._NgControl_38_6; }
    if (((token === import45.NgControlStatus) && ((38 <= requestNodeIndex) && (requestNodeIndex <= 41)))) { return this._NgControlStatus_38_7.context; }
    if (((token === import25.NgSelectOption) && ((57 <= requestNodeIndex) && (requestNodeIndex <= 58)))) { return this._NgSelectOption_57_3.context; }
    if (((token === import26.NgSelectMultipleOption) && ((57 <= requestNodeIndex) && (requestNodeIndex <= 58)))) { return this._NgSelectMultipleOption_57_4.context; }
    if (((token === import29.TemplateRef) && (60 === requestNodeIndex))) { return this._TemplateRef_60_5; }
    if (((token === import37.NgFor) && (60 === requestNodeIndex))) { return this._NgFor_60_6.context; }
    if (((token === import25.SelectControlValueAccessor) && ((55 <= requestNodeIndex) && (requestNodeIndex <= 61)))) { return this._SelectControlValueAccessor_55_3.context; }
    if (((token === import42.NG_VALUE_ACCESSOR) && ((55 <= requestNodeIndex) && (requestNodeIndex <= 61)))) { return this._NG_VALUE_ACCESSOR_55_4; }
    if (((token === import43.NgModel) && ((55 <= requestNodeIndex) && (requestNodeIndex <= 61)))) { return this._NgModel_55_5.context; }
    if (((token === import44.NgControl) && ((55 <= requestNodeIndex) && (requestNodeIndex <= 61)))) { return this._NgControl_55_6; }
    if (((token === import45.NgControlStatus) && ((55 <= requestNodeIndex) && (requestNodeIndex <= 61)))) { return this._NgControlStatus_55_7.context; }
    if (((token === import29.TemplateRef) && (71 === requestNodeIndex))) { return this._TemplateRef_71_5; }
    if (((token === import30.NgIf) && (71 === requestNodeIndex))) { return this._NgIf_71_6.context; }
    if (((token === import29.TemplateRef) && (73 === requestNodeIndex))) { return this._TemplateRef_73_5; }
    if (((token === import30.NgIf) && (73 === requestNodeIndex))) { return this._NgIf_73_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import23.ValueUnwrapper();
    this._SelectControlValueAccessor_38_3.ngDoCheck(this,this._el_38,throwOnChange);
    const currVal_38_1_0:any = this.context.carTemplateFilter.approvalStatus;
    this._NgModel_38_5.check_model(currVal_38_1_0,throwOnChange,false);
    this._NgModel_38_5.ngDoCheck(this,this._el_38,throwOnChange);
    this._NgControlStatus_38_7.ngDoCheck(this,this._el_38,throwOnChange);
    const currVal_40_0_0:any = this.context.approvalStatus;
    this._NgFor_40_6.check_ngForOf(currVal_40_0_0,throwOnChange,false);
    this._NgFor_40_6.ngDoCheck(this,this._anchor_40,throwOnChange);
    this._SelectControlValueAccessor_55_3.ngDoCheck(this,this._el_55,throwOnChange);
    const currVal_55_1_0:any = this.context.carTemplateFilter.countryOid;
    this._NgModel_55_5.check_model(currVal_55_1_0,throwOnChange,false);
    this._NgModel_55_5.ngDoCheck(this,this._el_55,throwOnChange);
    this._NgControlStatus_55_7.ngDoCheck(this,this._el_55,throwOnChange);
    const currVal_57_0_0:any = '';
    this._NgSelectOption_57_3.check_value(currVal_57_0_0,throwOnChange,false);
    this._NgSelectOption_57_3.ngDoCheck(this,this._el_57,throwOnChange);
    const currVal_57_1_0:any = '';
    this._NgSelectMultipleOption_57_4.check_value(currVal_57_1_0,throwOnChange,false);
    this._NgSelectMultipleOption_57_4.ngDoCheck(this,this._el_57,throwOnChange);
    const currVal_60_0_0:any = this.context.countries;
    this._NgFor_60_6.check_ngForOf(currVal_60_0_0,throwOnChange,false);
    this._NgFor_60_6.ngDoCheck(this,this._anchor_60,throwOnChange);
    const currVal_71_0_0:boolean = (!this.context.isLoading() && !!((this.context.page == null)? (null as any): this.context.page.pageItems));
    this._NgIf_71_6.check_ngIf(currVal_71_0_0,throwOnChange,false);
    this._NgIf_71_6.ngDoCheck(this,this._anchor_71,throwOnChange);
    const currVal_73_0_0:boolean = ((!this.context.isLoading() && !!((this.context.page == null)? (null as any): this.context.page.pageItems)) && (this.context.page.pageItems.length === 0));
    this._NgIf_73_6.check_ngIf(currVal_73_0_0,throwOnChange,false);
    this._NgIf_73_6.ngDoCheck(this,this._anchor_73,throwOnChange);
    this._vc_40.detectChangesInNestedViews(throwOnChange);
    this._vc_60.detectChangesInNestedViews(throwOnChange);
    this._vc_71.detectChangesInNestedViews(throwOnChange);
    this._vc_73.detectChangesInNestedViews(throwOnChange);
    valUnwrapper.reset();
    const currVal_104:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('carTemplate.moderation.TITLE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_104,currVal_104))) {
      this.renderer.setText(this._text_13,currVal_104);
      this._expr_104 = currVal_104;
    }
    valUnwrapper.reset();
    const currVal_106:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform('carTemplate.moderation.SUBTITLE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_106,currVal_106))) {
      this.renderer.setText(this._text_16,currVal_106);
      this._expr_106 = currVal_106;
    }
    valUnwrapper.reset();
    const currVal_108:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_2.transform('specialOffers.list.filters.title')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_108,currVal_108))) {
      this.renderer.setText(this._text_25,currVal_108);
      this._expr_108 = currVal_108;
    }
    valUnwrapper.reset();
    const currVal_110:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_3.transform('carTemplate.APPROVAL_STATUS')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_110,currVal_110))) {
      this.renderer.setText(this._text_34,currVal_110);
      this._expr_110 = currVal_110;
    }
    this._NgControlStatus_38_7.checkHost(this,this,this._el_38,throwOnChange);
    valUnwrapper.reset();
    const currVal_112:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_4.transform('specialOffers.moderation.filters.country.label')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_112,currVal_112))) {
      this.renderer.setText(this._text_51,currVal_112);
      this._expr_112 = currVal_112;
    }
    this._NgControlStatus_55_7.checkHost(this,this,this._el_55,throwOnChange);
    valUnwrapper.reset();
    const currVal_114:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_5.transform('common.ALL')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_114,currVal_114))) {
      this.renderer.setText(this._text_58,currVal_114);
      this._expr_114 = currVal_114;
    }
  }
  destroyInternal():void {
    this._vc_40.destroyNestedViews();
    this._vc_60.destroyNestedViews();
    this._vc_71.destroyNestedViews();
    this._vc_73.destroyNestedViews();
    this._NgModel_38_5.ngOnDestroy();
    this._NgSelectOption_57_3.ngOnDestroy();
    this._NgSelectMultipleOption_57_4.ngOnDestroy();
    this._NgModel_55_5.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
    this._pipe_translate_2.ngOnDestroy();
    this._pipe_translate_3.ngOnDestroy();
    this._pipe_translate_4.ngOnDestroy();
    this._pipe_translate_5.ngOnDestroy();
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 40)) { return new View_CarTemplateModerateComponent1(this.viewUtils,this,40,this._anchor_40,this._vc_40); }
    if ((nodeIndex == 60)) { return new View_CarTemplateModerateComponent2(this.viewUtils,this,60,this._anchor_60,this._vc_60); }
    if ((nodeIndex == 71)) { return new View_CarTemplateModerateComponent3(this.viewUtils,this,71,this._anchor_71,this._vc_71); }
    if ((nodeIndex == 73)) { return new View_CarTemplateModerateComponent11(this.viewUtils,this,73,this._anchor_73,this._vc_73); }
    return (null as any);
  }
  handleEvent_38(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    result = (this._SelectControlValueAccessor_38_3.handleEvent(eventName,$event) && result);
    if ((eventName == 'change')) {
      const pd_sub_0:any = ((<any>this.context.onChange()) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'ngModelChange')) {
      const pd_sub_1:any = ((<any>(this.context.carTemplateFilter.approvalStatus = $event)) !== false);
      result = (pd_sub_1 && result);
    }
    return result;
  }
  handleEvent_55(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    result = (this._SelectControlValueAccessor_55_3.handleEvent(eventName,$event) && result);
    if ((eventName == 'change')) {
      const pd_sub_0:any = ((<any>this.context.onChange()) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'ngModelChange')) {
      const pd_sub_1:any = ((<any>(this.context.carTemplateFilter.countryOid = $event)) !== false);
      result = (pd_sub_1 && result);
    }
    return result;
  }
}


// WEBPACK FOOTER //
// ./aot/public/upgrade/feature/carTemplate/moderate/car-template-moderate.component.ngfactory.ts